import { type GlobalImageSize} from "@rokid/store/src/parameter.ts"

export enum ItemType{
    globalImagesize = 18
}

export interface ParameterConfig{
    global_imagesize: GlobalImageSize
}